











import {defineComponent, reactive} from "@vue/composition-api"
import {getAutocompleteFn} from "@/data/sources/autocomplete"

interface Value {
  title: string,
  value: any,
}

export default defineComponent({
  props: {
    opts: {type: Object, required: true},
    default: {type: Object},
    value: {type: Object},
  },
  setup(props, context) {
    const options = props.opts.options || []
    const state = reactive({
      inputId: `enum-${String(Math.floor((Math.random() * 100000)))}`,
      options: [...options],
      selectedIndex: -1,
    })
    setTimeout(async () => {
      const fn = getAutocompleteFn(props.opts.autocompleteFn || "")
      const dynamicOptions = fn && await fn("") || []
      state.options.push(...dynamicOptions)
      context.root.$nextTick(() => state.selectedIndex = getIndex(props.value as Value))
    }, 0)

    function getIndex(value: Value | undefined): number {
      if (value === undefined || value.value === undefined) {
        return -1
      }
      let idx = -1
      if (typeof value !== 'object') {
        return idx
      }
      state.options.forEach((item, i) => {
        if (item.title === value.title) {
          idx = i
        }
      })
      return idx
    }

    function change(key: string) {
      context.emit('input', state.options[parseInt(key)])
    }

    return {state, change}
  },
})
